import { Controller } from "@hotwired/stimulus"

// Generic controller for revealing content based on a select value.
// Automatically finds the first <select> inside the controller element
// (no target needed on the select — works with ViewComponents that don't
// support custom data attributes on their rendered <select>).
//
// Usage:
//   data-controller="select-reveal"
//   data-select-reveal-trigger-value="custom" on the controller element
//   data-select-reveal-target="content" on the container to show/hide
export default class extends Controller {
  static targets = ["content"]
  static values = { trigger: String }

  connect() {
    this.selectElement = this.element.querySelector("select")
    if (this.selectElement) {
      this.changeHandler = () => this.toggle()
      this.selectElement.addEventListener("change", this.changeHandler)
    }
    this.toggle()
  }

  disconnect() {
    if (this.selectElement && this.changeHandler) {
      this.selectElement.removeEventListener("change", this.changeHandler)
    }
  }

  toggle() {
    if (!this.selectElement) return
    const isTriggered = this.selectElement.value === this.triggerValue
    this.contentTarget.style.display = isTriggered ? "block" : "none"
    this.contentTarget.querySelectorAll("input, select, textarea").forEach(input => {
      input.disabled = !isTriggered
    })
  }
}
